import { TReduxActions } from '../../../types/redux';
import { ENewReviewFormReviewAllowed } from '../../../actions/newReview';

export const defaultValue = false;

export function reviewAllowedReducer(state: boolean = defaultValue, { type, payload }: TReduxActions): boolean {
  if (type === ENewReviewFormReviewAllowed.Set) {
    return payload;
  }

  return state;
}
